import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import jspreadsheet from "jspreadsheet-ce";
import { configureJssGermanLocale } from "./lib/jssLocale";
import * as Sentry from "@sentry/vue";

configureJssGermanLocale(jspreadsheet);

router.afterEach((to) => {
  const newUrl = `${window.location.origin}${to.fullPath}`;
  if (window.Android && window.Android.onUrlChanged) {
    window.Android.onUrlChanged(newUrl);
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.urlChanged) {
    window.webkit.messageHandlers.urlChanged.postMessage(newUrl);
  }
});

const app=createApp(App)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: "https://07086f9fcd1d9de47a8db0cf1f06b0c4@o4509549361954816.ingest.de.sentry.io/4509549363396688",
    integrations: [Sentry.browserTracingIntegration()],
  
    tracesSampleRate: 1.0, // Adjust for production
    autoSessionTracking: true, // Explicit for clarity
    release: `casp-web@${process.env.VUE_APP_VERSION}`,
    sendDefaultPii: true
  });
  
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      registration.onupdatefound = () => {
        const newWorker = registration.installing;
  
        newWorker.onstatechange = () => {
          if (newWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New update available, notify user
                //window.location.reload();
            }
          }
        };
      };
    });
  }
}
  
app.use(router)
app.mount('#app')